<template>
  <div
    class="inputContainer fileUploader flex"
    :class="{
      containsError: onceUpdated && inputValidation,
      isFocus,
      'largeFileUploader border-dashed border-2 border-slate-400':
        largeFileUploader,
    }"
    v-if="type == 'picture' || type == 'file' || type == 'livevideo'"
    ref="inputContainer"
  >
    <div class="w-full h-full">
      <component
        :is="'FileUploader'"
        :acceptedFilesTypes="
          acceptedFilesTypes[0]
            ? acceptedFilesTypes
            : type == 'picture'
              ? ['image/*']
              : acceptedFilesTypes
        "
        :fileInputProperties="fileInputProperties"
        :fileId="inputText"
        @onFileChanged="
          (fileId, newFileName, pictureUrl) => {
            inputText = fileId
            inputText = pictureUrl
            fileName = newFileName
          }
        "
        :placeHolder="
          inputText
            ? alreadyExistPlaceHolder || placeHolder || inputText
            : placeHolder || 'Séléctionner une image'
        "
      >
        <div
          class="w-full h-full flex items-center justify-center"
          v-if="largeFileUploader"
        >
          <div class="flex flex-col items-center text-center">
            <div>
              <div class="w-[50px] h-[50px] border"></div>
            </div>
            <div class="py-1"></div>
            <div>
              <span class="" v-if="loaded && label">
                <div
                  class="truncate"
                  :style="{
                    maxWidth: $refs.inputContainer?.offsetWidth - 10 + 'px',
                  }"
                >
                  <span v-html="`${label}${required ? '' : ''}`"></span>
                </div>
              </span>
              <span class="description-color text-sm opacity-50">
                {{
                  inputText
                    ? alreadyExistPlaceHolder || placeHolder || inputText
                    : placeHolder || 'Séléctionner une image'
                }}
              </span>
              <div
                class="buttonComponent border rounded-full w-min px-4 py-2 mx-auto"
              >
                Sélectionner
              </div>
            </div>
          </div>
        </div>
      </component>
      <input
        :required="required"
        v-model="inputText"
        type="text"
        class="h-full w-full pointer-events-none opacity-0 absolute top-0"
        ref="input"
      />
      <span
        v-if="loaded && $refs.inputContainer && onceUpdated && inputValidation"
        class="errorContainer"
        smallDetail
      >
        <div
          class="text-xs truncate"
          :style="{
            maxWidth: $refs.inputContainer?.offsetWidth - 10 + 'px',
          }"
        >
          {{ inputValidation }}
        </div>
      </span>
      <label
        class="description-color"
        :class="{ placeholderExists: !!placeHolder }"
        v-if="loaded && label && $refs.inputContainer && !largeFileUploader"
      >
        <div
          class="truncate"
          :style="{
            maxWidth: $refs.inputContainer?.offsetWidth - 10 + 'px',
          }"
        >
          <span v-html="`${label}${required ? '' : ''}`"></span>
        </div>
      </label>
    </div>
  </div>
  <div
    class="inputContainer flex"
    :class="{ isFocus }"
    v-else-if="type == 'select'"
    ref="inputContainer"
    @click="
      () => {
        onSelectInputClickFunction ? onSelectInputClickFunction() : null
      }
    "
  >
    <DropdownComponent
      :hideSelectedCheck="hideSelectedCheck"
      :useModal="useModal"
      :selects="
        options.map((option, i) => {
          return {
            option: option,
            selectDisplay: selectInputDisplays[i] || option,
          }
        })
      "
      maxHeight="270px"
      :minWidth="($refs.inputContainer?.offsetWidth || 350) + 'px'"
      :onSelect="
        selected => {
          inputText = selected.option
          valueToDisplay = selected.selectDisplay
        }
      "
      displayKey="option"
      :selectedValue="inputText"
      class="w-full h-full"
      :class="{
        containsError: onceUpdated && inputValidation,
        'pointer-events-none': disabled,
      }"
      :title="selectTitle"
      :subTitle="selectSubTitle"
    >
      <input
        :required="required"
        :disabled="disabled"
        v-model="inputText"
        :type="type === 'password' && showPassword ? 'text' : type"
        class="h-full w-full pointer-events-none absolute opacity-0"
        :placeholder="placeHolder || ' '"
        ref="input"
        @keydown.prevent="() => {}"
      />
      <input
        @keydown.prevent="() => {}"
        :required="required"
        :disabled="disabled"
        :value="valueToDisplay || inputText"
        :type="type === 'password' && showPassword ? 'text' : type"
        class="h-full w-full pointer-events-none"
        :placeholder="placeHolder || ' '"
      />
      <span
        v-if="loaded && $refs.inputContainer && onceUpdated && inputValidation"
        class="errorContainer"
        smallDetail
      >
        <div
          class="text-xs truncate"
          :style="{
            maxWidth: $refs.inputContainer?.offsetWidth - 10 + 'px',
          }"
        >
          {{ inputValidation }}
        </div>
      </span>
      <span
        v-else-if="detailText"
        class="detailContainer description-color"
        smallDetail
      >
        <div
          class="text-xs pb-1"
          :style="{
            maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
          }"
        >
          <span v-html="detailText"></span>
        </div>
      </span>
      <label
        class="description-color"
        :class="{ placeholderExists: !!placeHolder }"
        v-if="loaded && label && $refs.inputContainer"
      >
        <div
          class="truncate"
          :style="{
            maxWidth: $refs.inputContainer?.offsetWidth - 10 + 'px',
          }"
        >
          <span v-html="`${label}${required ? '' : ''}`"></span>
        </div>
      </label>
    </DropdownComponent>
  </div>
  <div
    class="inputContainer activateLabelClick flex"
    v-else-if="type == 'toggle'"
    :class="{ isFocus }"
    ref="inputContainer"
  >
    <label class="relative flex items-center cursor-pointer">
      <input
        type="checkbox"
        v-model="inputText"
        value=""
        class="sr-only peer"
        ref="input"
        :required="required"
        :disabled="disabled"
      />
      <div
        class="w-11 h-6 relative -t-1 bg-gray-700 peer-focus:outline-none peer-focus:ring-0 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-500"
      ></div>
      <span class="ml-3" titleColor>
        <span v-html="`${label}${required ? '' : ''}`"></span>
      </span>
    </label>

    <span
      v-if="loaded && $refs.inputContainer && onceUpdated && inputValidation"
      class="errorContainer"
      smallDetail
    >
      <div
        class="text-xs truncate"
        :style="{
          maxWidth: $refs.inputContainer?.offsetWidth - 10 + 'px',
        }"
      >
        {{ inputValidation }}
      </div>
    </span>
    <span
      v-else-if="detailText"
      class="description-color detailContainer"
      smallDetail
    >
      <div
        class="text-xs pb-1"
        :style="{
          maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
        }"
      >
        <span v-html="detailText"></span>
      </div>
    </span>
  </div>
  <div
    v-else-if="type == 'phoneNumber'"
    :class="{
      inputContainer: phoneCondensed,
      containsError: onceUpdated && inputValidation,
      isFocus,
    }"
    ref="inputContainer"
  >
    <ListItemLayout class="h-full w-full flex">
      <template #left>
        <div
          ref="countryCodeSelector"
          :class="{
            inputContainer: !phoneCondensed,
            'border-r border-red': phoneCondensed,
          }"
          class="h-full mr-2 px-2"
        >
          <DropdownComponent
            class="w-full h-full"
            :disabled="countryCodeUpdateDisabled"
            :dropdownMaxHeight="(bodyHeight * 30) / 100 + 'px'"
            :selects="countries"
            :onSelect="
              selected => {
                phoneNumberCountry = selected
              }
            "
            :initDropdownFunctions="
              showDropdown => {
                showCountrySelectDropdown = showDropdown
              }
            "
            displayKey="display"
          >
            <div class="flex items-center justify-center">
              +{{ phoneNumberCountry.callingCode }}
            </div>
          </DropdownComponent>
        </div>
      </template>
      <template #default>
        <input
          :style="{
            width: '100%',
          }"
          borderless
          :required="required"
          :disabled="disabled"
          v-model="inputPhoneNumberText"
          :label="phoneLabel"
          type="tel"
          clsss="h-full"
          :placeholder="placeHolder || ' '"
          ref="input"
        />
        <span
          v-if="loaded && onceUpdated && inputValidation"
          class="errorContainer"
          smallDetail
        >
          <div
            class="text-xs truncate"
            :style="{
              maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
            }"
          >
            {{ inputValidation }}
          </div>
        </span>
        <span
          v-else-if="detailText"
          class="detailContainer description-color"
          smallDetail
        >
          <div
            class="text-xs pb-1"
            :style="{
              maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
            }"
          >
            <span v-html="detailText"></span>
          </div>
        </span>
        <label
          class="defaultToTop description-color"
          :class="{ placeholderExists: !!placeHolder }"
          v-if="loaded && label"
        >
          <div
            class="truncate"
            :style="{
              maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
            }"
          >
            <span v-html="`${label}${required ? '' : ''}`"></span>
          </div>
        </label>
      </template>
    </ListItemLayout>
  </div>
  <div
    class="inputContainer flex"
    :class="[
      {
        containsError: onceUpdated && (inputValidation || inputValidation),
        isFocus,
        withPrefix: !!prefix,
        withSuffix: !!suffix,
      },
      `type-${type}`,
    ]"
    v-else
    ref="inputContainer"
  >
    <button
      type="button"
      @click="
        () => {
          if (inputText <= min) return
          inputText--
        }
      "
      class="bg-gray-50 text-sm rounded-l-lg w-[60px] flex h-full"
      v-if="type == 'number' && showPlusMinusButtons"
    >
      <svg class="m-auto w-3 h-3" fill="none" viewBox="0 0 18 2">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M1 1h16"
        />
      </svg>
    </button>

    <div
      class="absolute prefix top-[14px] left-4 opacity-0"
      :class="{ 'opacity-100': isFocus || inputText }"
      v-if="!!prefix"
    >
      <span v-html="prefix"></span>
    </div>
    <div
      class="absolute suffix top-[14px] right-4 opacity-0"
      :class="{ 'opacity-100': isFocus || inputText }"
      v-if="!!suffix"
    >
      <span v-html="suffix"></span>
    </div>
    <div
      class="absolute suffix top-[14px] right-4 opacity-0 flex items-center justify-center"
      :class="{ 'opacity-100': isFocus || inputText }"
      v-if="type == 'password'"
      @click="showPassword = !showPassword"
    >
      <img
        v-if="$ColorTheme.isLight()"
        src="~@/assets/images/all/eye.png"
        class="w-6 h-6 opacity-50"
        alt=""
      />
      <img
        v-else
        src="~@/assets/images/all/eye-white.svg"
        class="w-6 h-6 opacity-50"
        alt=""
      />
    </div>
    <input
      v-bind="{
        ...fileInputProperties,
        ...(type == 'number' ? { inputmode: 'numeric' } : {}),
      }"
      :required="required"
      :disabled="disabled"
      v-model="inputText"
      :type="
        type === 'password' && showPassword
          ? 'text'
          : type === 'number' && allowTrailingZero
            ? 'text'
            : type
      "
      :class="{
        empty: $Commons.isEmpty(inputText),
        'w-[49%] ': doubleValue,
        'w-full ': !doubleValue,
        'hidden opacity-0 pointer-events-none': type === 'textarea',
      }"
      class="h-full"
      :placeholder="placeHolder || ' '"
      :step="numberStep"
      ref="input"
      @focus="isFocus = true"
      @blur="isFocus = false"
    />
    <textarea
      class="!h-full overflow-auto w-full"
      :class="{
        empty: $Commons.isEmpty(inputText),
      }"
      :placeholder="placeHolder || ' '"
      v-if="type === 'textarea'"
      v-model="inputText"
      @focus="isFocus = true"
      @blur="isFocus = false"
    >
    </textarea>
    <span
      v-if="loaded && onceUpdated && inputValidation"
      class="errorContainer"
      smallDetail
    >
      <div
        class="text-xs truncate"
        :style="{
          maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
        }"
      >
        {{ inputValidation }}
      </div>
    </span>
    <span
      v-else-if="detailText"
      class="detailContainer description-color"
      smallDetail
    >
      <div
        class="text-xs pb-1"
        :style="{
          maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
        }"
      >
        <span v-html="detailText"></span>
      </div>
    </span>
    <label
      class="description-color"
      :class="{ placeholderExists: !!placeHolder }"
      v-if="loaded && label"
    >
      <div
        class="truncate"
        :style="{
          maxWidth: ($refs.inputContainer?.offsetWidth || 100) - 10 + 'px',
        }"
      >
        <span v-html="`${label}${required ? '' : ''}`"></span>
      </div>
    </label>
    <button
      type="button"
      @click="
        () => {
          if (inputText >= max) return
          inputText++
        }
      "
      class="bg-gray-50 text-sm rounded-r-lg w-[60px] flex h-full"
      v-if="type == 'number' && showPlusMinusButtons"
    >
      <svg class="m-auto w-3 h-3" fill="none" viewBox="0 0 18 18">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 1v16M1 9h16"
        />
      </svg>
    </button>
    <div class="h-[48px] border border-[#efefef]" v-if="doubleValue"></div>
    <input
      v-if="doubleValue"
      :required="required2"
      :disabled="disabled2"
      v-model="inputText2"
      :label="label2"
      :type="type2 === 'password' && showPassword2 ? 'text' : type2"
      class="w-[49%] ml-auto h-full"
      :placeholder="placeHolder2 || ' '"
      ref="input2"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import TextComponent from '@/components/utils/TextComponent.vue'
import ListItemLayout from '@/components/utils/ListItemLayout.vue'
import FileUploader from '@/components/utils/FileUploader.vue'

export default defineComponent({
  name: 'InputComponent',
  components: {
    DropdownComponent,
    TextComponent,
    ListItemLayout,
    FileUploader,
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: '',
    },
    doubleValue: {
      type: Boolean,
      default: false,
    },
    modelValue2: {
      type: [String, Number, Boolean],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    label2: {
      type: String,
      default: '',
    },
    detailText: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: [String, Number],
      default: '',
    },
    fullPhoneNumber: {
      type: [String, Number],
      default: '',
    },
    countryCode: {
      type: String,
      default: '',
    },
    countryCodeUpdateDisabled: {
      type: Boolean,
      default: false,
    },
    blockEmoji: {
      type: Boolean,
      default: true,
    },
    phoneLabel: {
      type: [String, Number],
      default: 'Téléphone',
    },
    type: {
      type: String,
      default: '',
    },
    type2: {
      type: String,
      default: '',
    },
    phoneCondensed: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    required2: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabled2: {
      type: Boolean,
      default: false,
    },
    showPlusMinusButtons: {
      type: Boolean,
      default: false,
    },
    useModal: {
      type: Boolean,
      default: false,
    },
    hideSelectedCheck: {
      type: Boolean,
      default: false,
    },
    allowTrailingZero: {
      type: Boolean,
      default: false,
    },
    alreadyExistPlaceHolder: {
      type: String,
      default: '',
    },
    largeFileUploader: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    placeHolder2: {
      type: String,
      default: '',
    },
    selectTitle: {
      type: String,
      default: '',
    },
    selectSubTitle: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    forceUppercase: {
      type: Boolean,
      default: false,
    },
    trim: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [Number, String],
      default: 0,
    },
    minLenght: {
      type: [Number, String],
      default: 0,
    },
    min2: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: [Number, String],
      default: '',
    },
    max2: {
      type: [Number, String],
      default: 10000000000000,
    },
    numberStep: {
      type: [Number, String],
      default: 1,
    },
    validate: {
      type: Function,
      default: () => {
        return ''
      },
    },
    validate2: {
      type: Function,
      default: () => {
        return ''
      },
    },
    init: {
      type: Function,
      default: reloadInputContent => {},
    },
    options: {
      type: Array,
      default: () => {
        return []
      },
    },
    onSelectInputClickFunction: {
      type: Function,
      default: () => {},
    },
    selectInputDisplays: {
      type: Array,
      default: () => {
        return []
      },
    },
    acceptedFilesTypes: {
      type: Array,
      default: () => {
        return []
      },
    },
    fileInputProperties: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  emits: [
    'update:value',
    'update:modelValue',
    'input:value',
    'input:modelValue',
    'update:modelValue2',
    'update:countryCode',
    'update:phoneNumber',
    'update:fullPhoneNumber',
    'update:country',
    'valueWillChange',
  ],
  data() {
    return {
      showPassword: false,
      showPassword2: false,
      inputText: '',
      inputText2: '',
      inputPhoneNumberText: '',
      phoneNumberCountry: {
        countryCode: 'DZ',
        countryCodeLowerCase: 'dz',
        countryName: 'Algeria',
        callingCode: 213,
        officialLanguage: 'Arabic',
        capital: 'Algiers',
        countryFlag: '🇩🇿',
        depositSupported: false,
        collectionSupported: true,
        currency: '',
      },
      onceUpdated: false,
      fileName: '',
      onceUpdated2: false,
      watchOnceUpdate: false,
      loaded: false,
      isFocus: false,
      valueToDisplay: '',
    }
  },
  mounted() {
    this.reloadInputContent()
    this.init(this.reloadInputContent)
    setTimeout(() => {
      this.watchOnceUpdate = true
    }, 2000)
    this.loaded = true
  },
  methods: {
    reloadInputContent() {
      this.inputText = this.modelValue || this.value
      this.inputText2 = this.modelValue2
      if (this.type == 'phoneNumber') this.initPhoneNumber()
      this.makeInputValidation()
    },
    initPhoneNumber() {
      const beninCountry = this.$Countries.find('ci')
      this.phoneNumberCountry =
        this.$Countries.find(this.inputText) ||
        this.$Countries.find(this.countryCode) ||
        beninCountry
      if (this.phoneNumber) this.inputPhoneNumberText = this.phoneNumber
      else if (this.fullPhoneNumber) {
        this.onFullPhoneNumberUpdated(this.fullPhoneNumber)
      } else {
        this.onFullPhoneNumberUpdated(this.modelValue || this.value)
      }
    },
    onFullPhoneNumberUpdated(fullPhoneNumber) {
      let phoneNumber = fullPhoneNumber.substring(3)
      this.inputPhoneNumberText = phoneNumber
      this.phoneNumberCountry =
        this.$Countries.getPhoneCountry(fullPhoneNumber) ||
        this.phoneNumberCountry ||
        this.$Countries.find('bj')
    },
    getInputValidation(newValue = this.inputText, input2 = false) {
      if (this.disabled) return ''
      if (this.validate(newValue)) return this.validate(newValue)
      if (this.validateRequired(newValue, this.type, this.required)) {
        return this.validateRequired(newValue, this.type, this.required)
      }
      if (this.validateType(newValue, this.type)) {
        return this.validateType(newValue, this.type)
      }
      if (this.validateMin(newValue, this.type, this.min)) {
        return this.validateMin(newValue, this.type, this.min)
      }
      if (this.validateMax(newValue, this.type, this.max)) {
        return this.validateMax(newValue, this.type, this.max)
      }
      if (this.validateMinLenght(newValue, this.minLenght)) {
        return this.validateMinLenght(newValue, this.minLenght)
      }
      return ''
    },
    validateType(value, inputType) {
      if (inputType == 'email') {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))
          return ''
        return 'Email incorrect correct'
      }
      if (inputType == 'text') {
        if (
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/.test(
            value,
          )
        )
          return 'Les emogis ne sont pas autorisé'
        return ''
      }
      if (inputType == 'number') {
        if (isNaN(parseFloat(value))) return 'Valeur incorrect'
        if (isFinite(value)) return ''
        return 'Valeur incorrect'
      }
      if (inputType == 'toggle') {
        if (typeof value == 'boolean') return ''
        return 'Valeur incorrect'
      }
      return ''
    },
    validateRequired(value, inputType, required) {
      if (!required) return ''
      if (inputType == 'number' && value == 0) return ''
      if (inputType == 'toggle') return ''
      if (!value) return 'Ce champ est requis'
    },
    validateMin(value, inputType, min) {
      if (inputType !== 'number') return ''
      if (value >= min) return ''
      return 'Le minimum est ' + min
    },
    validateMax(value, inputType, max) {
      if (inputType !== 'number') return ''
      if (!max) return ''
      if (value <= max) return ''
      return 'Le maximum est ' + max
    },
    validateMinLenght(value, minLenght) {
      if (`${value}`.length >= minLenght) return ''
      return 'Cette valeur est trop courte '
    },
    externalSetValue(value) {
      this.inputText = value
      if (this.watchOnceUpdate) this.onceUpdated = true
      this.makeInputValidation()
    },
    makeInputValidation() {
      if (this.$refs.input) {
        const validationReponse = this.getInputValidation()
        this.$refs.input.setCustomValidity(validationReponse)
      }
    },
  },
  watch: {
    value(newValue) {
      this.inputText = newValue
      if (this.watchOnceUpdate) this.onceUpdated = true
      this.makeInputValidation()
    },
    modelValue(newValue) {
      this.inputText = newValue
      if (this.watchOnceUpdate) this.onceUpdated = true
    },
    modelValue2(newValue) {
      this.inputText2 = newValue
      if (this.watchOnceUpdate) this.onceUpdated2 = true
    },
    inputText(newValue, old) {
      const isTextType = this.type == 'text' || this.type == 'textarea'
      if (
        this.forceUppercase &&
        isTextType &&
        `${newValue}`.toUpperCase() != newValue
      ) {
        this.inputText = `${newValue}`.toUpperCase()
        this.$forceUpdate()
        return
      }
      if (this.trim && isTextType && `${newValue}`.trim() != newValue) {
        console.log('will trim')
        this.inputText = `${newValue}`.trim()
        this.$forceUpdate()
        return
      }
      if (this.options && this.selectInputDisplays) {
        const selectedKey = this.options.indexOf(newValue)
        if (selectedKey > -1) {
          this.valueToDisplay = this.selectInputDisplays[selectedKey]
        }
      }
      if (this.type == 'number' && newValue !== '') {
        const intValue = parseFloat(newValue)
        if (intValue !== newValue && !this.allowTrailingZero) {
          this.inputText = intValue || 0
          this.$forceUpdate()
          return
        }
        if (this.fileInputProperties?.maxlength) {
          const size = `${intValue}`.length
          if (size > this.fileInputProperties?.maxlength) {
            this.inputText = old
            this.$forceUpdate()
            return
          }
        }
        if (this.max) {
          if (intValue > this.max) {
            this.inputText = this.max
            this.$forceUpdate()
            return
          }
        }
        if (/^0{2,}/i.test(`${newValue}`)) {
          this.inputText = old || 0
          this.$forceUpdate()
          return
        }
      }
      this.$forceUpdate()
      this.$emit('update:modelValue', newValue)
      this.$emit('input:modelValue', newValue)
      this.$emit('input', newValue)
      const vue = this
      this.$emit('valueWillChange', {
        newValue,
        reset(resetValue = old) {
          vue.inputText = resetValue
        },
      })

      this.makeInputValidation()
      if (this.watchOnceUpdate) this.onceUpdated = true
      this.$forceUpdate()
    },
    inputText2(newValue) {
      this.$emit('update:modelValue2', newValue)
      if (this.watchOnceUpdate) this.onceUpdated2 = true
    },
    countryCode(newValue) {
      this.phoneNumberCountry =
        this.$Countries.find(newValue) ||
        this.phoneNumberCountry ||
        this.$Countries.find('bj')
    },
    phoneNumber(newValue) {
      this.inputPhoneNumberText = newValue
    },
    fullPhoneNumber(newValue) {
      this.onFullPhoneNumberUpdated(newValue)
    },
    phoneNumberCountry(newValue) {
      this.$emit('update:countryCode', newValue.countryCode)
      this.$emit('update:country', newValue)
      this.$emit(
        'update:fullPhoneNumber',
        newValue.callingCode + this.inputPhoneNumberText,
      )
    },
    inputPhoneNumberText(newValue) {
      this.$emit('input', this.phoneNumberCountry.callingCode + newValue)
      this.$emit('update:phoneNumber', newValue)
      this.$emit(
        'update:fullPhoneNumber',
        this.phoneNumberCountry.callingCode + newValue,
      )
    },
  },
  computed: {
    inputValidation() {
      return this.getInputValidation()
    },
    countries() {
      return this.$Countries
        .getByCountryCode(this.options || ['BJ'])
        .map(country => {
          return {
            ...country,
            countryCode: country.countryCode,
            display: country.countryFlag + ' +' + country.callingCode,
            callingCode: country.callingCode,
          }
        })
    },
    bodyHeight() {
      return document.body.offsetHeight
    },
  },
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.inputContainer {
  margin-top: var(--inputcomponent-margin-top);
  margin-bottom: var(--inputcomponent-margin-bottom);
  height: var(--inputcomponent-height);
  background-color: var(--inputcomponent-background-color);
  border: var(--inputcomponent-border);
  border-radius: var(--inputcomponent-border-radius);
  width: var(--inputcomponent-width);
  position: relative;
}
.inputContainer.isFocus {
  /* border-color: var(--inputcomponent-focus-border-color); */
}
.inputContainer.pictureUploader {
  /* height: 200px; */
}
.inputContainer.type-textarea {
  height: 100px;
}
.inputContainer input,
.inputContainer textarea {
  border-radius: 10px;
  padding: 0px 10px;
  color: var(--title-color);
  background-color: transparent;
}
.inputContainer.withPrefix input,
.inputContainer.withPrefix textarea {
  padding-left: 45px;
}
.inputContainer.withSuffix input,
.inputContainer.withSuffix textarea {
  padding-right: 45px;
}

.inputContainer textarea {
  padding: 10px !important;
}

input,
textarea {
  outline: none !important;
}

.inputContainer label {
  transition-duration: 0.3s;
  position: absolute;
  pointer-events: none;
  font-size: var(--inputcomponent-label-font-size);
  left: 10px;
  top: var(--inputcomponent-label-position-top);
  background: linear-gradient(
    to top,
    white,
    white 54%,
    transparent 54%,
    transparent 100%
  );
  background: transparent !important;
  border-radius: 6px;
  user-select: none;
}

.inputContainer.activateLabelClick label {
  pointer-events: all;
}

.inputContainer input ~ label.defaultToTop,
.inputContainer input ~ label.placeholderExists,
.inputContainer input:focus ~ label,
.inputContainer input:not(:placeholder-shown) ~ label,
.inputContainer input:not(.empty) ~ label {
  background: linear-gradient(
    to top,
    white,
    white 54%,
    transparent 54%,
    transparent 100%
  );
  padding: 0 4px;
  left: 6px;
  top: -10px;
  font-size: var(--inputcomponent-focus-label-font-size);
}

.inputContainer input:focus ~ label/* ,
.inputContainer input:not(:placeholder-shown) ~ label,
.inputContainer input:valid:not(.empty) ~ label */ {
  /* color: var(--inputcomponent-focus-label-color); */
}

.inputContainer .errorContainer,
.inputContainer .detailContainer {
  position: absolute;
  pointer-events: none;
  user-select: none;
  left: 5px;
  top: 105%;
  color: #bfbfbf;
}

.inputContainer.containsError {
  /* border-color: theme("colors.red.300"); */
  /* border-color: theme("colors.gray.300"); */
}
.inputContainer.containsError input ~ label,
.inputContainer.containsError .errorContainer {
  /* color: theme("colors.red.400") !important; */
}

.inputContainer.containsError .errorContainer {
  display: none;
}
</style>
